import { axiosGet, axiosPost, axiosPatch } from "../lib/apiUtil";

export const getNotifications = () => {
  return axiosGet(`/notifications`);
};

export const markNotificationAsRead = (notificationId) => {
  return axiosGet(`/notifications/${notificationId}`);
};
